import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  OffersStore,
} from '../../mobx-store/stores/offersStore';
import classes from './addEditOffer.module.scss';
import { ScreenAPI, screens } from 'screens/addEditCustomScreen/widgets/constants';
import CustomScreens from 'mobx-store/stores/customScreens/customScreensStore';
import { CustomScreensStore } from 'mobx-store/stores/customScreens';
import { stores } from 'mobx-store';
import { ICountry } from 'mobx-store/storeInterfaces/authInterface';


enum NvigationType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
  NATIVE = 'NATIVE'
}

enum InternalNavigationFields {
  navigationEntityId = 'navigationEntityId',
  navigationEntityParams = 'navigationEntityParams'
}

enum ExternalNavigationFields {
  navigationURI = 'navigationURI',
}

enum NativeNavigationFields {
  nativeModuleName = 'nativeModuleName',
  nativeModuleMethodName = 'nativeModuleMethodName'
}
interface IProps extends WithSnackbarProps {
  offersStore: OffersStore;
  customScreensStore: CustomScreensStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  processing: boolean;
  selectedLang: string;
}



@inject('offersStore')
@inject('customScreensStore')
@observer
export class AddEditOffer extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  offerId = -1;

  pageTitle = '';

  offerFormTitle = '';

  offerSchema: any;

  submitButton: any;

  cancelButton: any;

  lastHistory = -1;

  dropdownLanguages: {
    langList: { langCode: string; langValue: string }[];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  customScreens = this.props.customScreensStore.Stores.customScreens;


  NAVIGATION: { [key: string]: FormField[] } = {
    [NvigationType.INTERNAL]: [
      {
        name: InternalNavigationFields.navigationEntityId,
        label: 'Entity Id',
        selectList: screens.map(n => ({ key: n.name, value: n.name })),
        selectListValue: 'value',
        selectListKey: 'key',
        filedType: 'DropdownField',
      }
    ],
    [NvigationType.EXTERNAL]: [
      {
        name: ExternalNavigationFields.navigationURI,
        label: 'URI',
        type: 'text',
        filedType: 'InputField',
      },
    ],
    [NvigationType.NATIVE]: [
      {
        name: NativeNavigationFields.nativeModuleName,
        label: 'nativeModuleName',
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: NativeNavigationFields.nativeModuleMethodName,
        label: 'nativeModuleMethodName',
        type: 'text',
        filedType: 'InputField',
      },
    ]
  }

  selectedScreenChange = (name: string) => {
    const screen = screens.find(screen => screen.name === name);
    if (screen && screen.api) {
      this.getSubScreensList(screen.api);
    }
  };

  getSubScreensList = async (api: ScreenAPI) => {
    try {
      await this.customScreens.getScreensList(api);
    } catch (error) {
      console.log(error);
    }
  };
  initializeComponent(props: IProps & RouteComponentProps,
    isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.offerId = props.match.params.id;
      this.pageTitle = translate('editOfferPageTitle');
    } else {
      this.isNew = true;
      this.pageTitle = translate('addOfferPageTitle');
    }
    this.initOfferSchema();
    this.initState(isConstructor);
    this.offerFormTitle = translate('offerFormTitle');
    this.dropdownLanguages = this.getDropdownLanguages();
  }

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false);
      this.forceUpdate();
      if (!this.isNew) {
        this.getOffer(languageCodes.english);
      }
    }
  }

  handelLanguageChange = (langCode: string) => {
    if (langCode !== this.state.selectedLang) {
      if (this.isNew) {
        this.setState({
          selectedLang: langCode,
        });
      } else {
        this.getOffer(langCode);
      }
    }
  };

  initOfferSchema = () => {
    this.offerSchema = Yup.object().shape({
      title: Yup.string().required('Required'),
      expirationDate: Yup.date().required('Required'),
      description: Yup.string().required('Required'),
      terms: Yup.string().required('Required'),
      steps: Yup.string().required('Required'),
      imageURL: Yup.array().required('Required'),
      iconURL: Yup.array().required('Required'),
      isActive: Yup.boolean().default(true),
      isHotDeal: Yup.boolean().default(false),
      discountPercentage: Yup.number().required('Required'),
      navigationType: Yup.string()
        .required('Navigation type is required')
        .oneOf([NvigationType.INTERNAL, NvigationType.EXTERNAL, NvigationType.NATIVE], 'Navigation type must be either "internal" or "external"'),

      navigationURI: Yup.string().when('navigationType', {
        is: NvigationType.EXTERNAL,
        then: Yup.string().required('Navigation URI is required for external types'),
        otherwise: Yup.string().notRequired()
      }),

      navigationEntityId: Yup.string().when('navigationType', {
        is: NvigationType.INTERNAL,
        then: Yup.string().required('Navigation Entity ID is required for internal types'),
        otherwise: Yup.string().notRequired()
      }),

      navigationEntityParams: Yup.string().when('navigationType', {
        is: NvigationType.INTERNAL,
        then: Yup.string().optional(),
        otherwise: Yup.string().notRequired()
      })
    });
  };
  getFormFields = (): FormField[] => {

    return [
      {
        name: 'title',
        label: translate('title'),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'description',
        label: translate('description'),
        type: 'text',
        filedType: 'RichTextField',
      },
      {
        name: 'terms',
        label: translate('terms'),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'steps',
        label: translate('steps'),
        filedType: 'RichTextField',
      },
      {
        name: 'expirationDate',
        label: 'Expiration Date',
        filedType: 'DatePickerField',
        minDate: this.isNew ? new Date() : undefined,
      },
      {
        name: 'discountPercentage',
        label: translate('DiscountPercentage'),
        filedType: 'InputField',
      },
      {
        name: 'imageURL',
        label: translate('addImagePageFormImage'),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        size: 200,
      },
      {
        name: 'iconURL',
        label: translate('addIconPageFormImage'),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        size: 200,
      },
      {
        name: 'isActive',
        label: translate('Status'),
        filedType: 'ToggleButtonField',
        activeLabel: translate('FormActiveLabel'),
        inactiveLabel: translate('FormActiveLabel'),
        value: true,
      },
      {
        name: 'isHotDeal',
        label: translate('HotDeal'),
        filedType: 'ToggleButtonField',
        activeLabel: translate('HotDeal'),
        inactiveLabel: translate('NotHotDeal'),
        value: false,
      },
      {
        name: 'navigationType',
        label: 'Navigation type',
        selectList: Object.values(NvigationType).map(n => ({ key: n, value: n })),
        selectListValue: 'value',
        selectListKey: 'key',
        filedType: 'DropdownField',
        // value: NvigationType.EXTERNAL,
      },
    ];
  };

  initState = (isConstructor = true) => {
    const initState: IState = {
      selectedLang: languageCodes.english,
      processing: false,
      loading: !this.isNew,
      formFields: this.getFormFields(),
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  handleSubmit = async (values: any): Promise<void> => {
    this.setState({
      processing: true,
    });
    await stores.countryStore.getUserManagedCountries();

    values.availableCountries = stores.countryStore.managedCountries.map((country: ICountry) => country.isoCode);

    if (this.isNew) {
      try {

        this.props.offersStore.createOffer(values)
          .then((offerId) => {
            this.setState({
              processing: false,
            });
            SnackBarComponent.getInstance().openSnackbar(translate('createdMessage'), 5000, 'success');
            this.props.history.replace(`${offerId}/edit`);
          });
      } catch {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage'), 5000, 'error');
      }
    } else {
      this.props.offersStore.updateOffer(values, this.offerId, this.state.selectedLang)
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage'), 5000, 'success');
          this.props.history.goBack();
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage'), 5000, 'error');
        });
    }
  };

  handleCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handleCancel,
  });

  updateStateWithOfferData = async () => {
    const formFieldsWithData = [];
    const selectedOffer: any = this.props.offersStore.selectedOffer;
    const formFieldsList = this.state.formFields;
    if (selectedOffer?.navigationType === NvigationType.INTERNAL) {
      formFieldsList.push({
        name: InternalNavigationFields.navigationEntityId,
        label: 'Entity Id',
        selectList: screens.map(n => ({ key: n.name, value: n.name })),
        selectListValue: 'value',
        selectListKey: 'key',
        filedType: 'DropdownField',
      });
      const entityId = selectedOffer[InternalNavigationFields.navigationEntityId];
      if (entityId) {
        const selectedApi = screens.find(s => s.name === entityId)?.api;
        if (selectedApi) {
          await this.getSubScreensList(selectedApi);
          formFieldsList.push({
            name: InternalNavigationFields.navigationEntityParams,
            label: 'Entity Params',
            selectList: this.customScreens.screensList.map(s => ({ key: s.id.toString(), value: s.title.toString() })),
            selectListValue: 'value',
            selectListKey: 'key',
            filedType: 'DropdownField',
          })
        }
      }
    } else if (selectedOffer?.navigationType === NvigationType.EXTERNAL) {
      formFieldsList.push({
        name: ExternalNavigationFields.navigationURI,
        label: 'URI',
        type: 'text',
        filedType: 'InputField',
      });
    } else if (selectedOffer?.navigationType === NvigationType.NATIVE) {
      formFieldsList.push({
        name: NativeNavigationFields.nativeModuleName,
        label: 'nativeModuleName',
        type: 'text',
        filedType: 'InputField',
      });
      formFieldsList.push({
        name: NativeNavigationFields.nativeModuleMethodName,
        label: 'nativeModuleMethodName',
        type: 'text',
        filedType: 'InputField',
      });
    }
    for (const field of formFieldsList) {
      formFieldsWithData.push({
        ...field, value: (selectedOffer as any)[field.name],
      });
    }
    this.setState({
      formFields: formFieldsWithData, loading: false,
    });
  };

  generalFormChanges = async (key: string, value: string) => {
    if (key === 'navigationType') {
      const formFields = Object.assign(this.state.formFields, []);
      const filteredFormFields = formFields.filter(f => ![
        InternalNavigationFields.navigationEntityId,
        InternalNavigationFields.navigationEntityParams,
        ExternalNavigationFields.navigationURI,
        NativeNavigationFields.nativeModuleName,
        NativeNavigationFields.nativeModuleMethodName
      ].includes(f.name as InternalNavigationFields || ExternalNavigationFields));
      this.setState({
        formFields: [
          ...filteredFormFields,
          ...this.NAVIGATION[value]
        ]
      });
    } else if (key === InternalNavigationFields.navigationEntityId) {
      const formFields = Object.assign(this.state.formFields, []);
      const filteredFormFields = formFields.filter(f => ![
        InternalNavigationFields.navigationEntityParams,
      ].includes(f.name as InternalNavigationFields));
      const screen = screens.find(s => s.name === value);
      if (!screen?.api) {
        this.setState({ formFields: filteredFormFields });
      } else {
        this.setState({
          processing: true,
        })
        await this.getSubScreensList(screen?.api);
        this.setState({
          processing: false,
          formFields: [
            ...filteredFormFields,
            {
              name: InternalNavigationFields.navigationEntityParams,
              label: 'Entity Params',
              selectList: this.customScreens.screensList.map(s => ({ key: s.id.toString(), value: s.title.toString() })),
              selectListValue: 'value',
              selectListKey: 'key',
              filedType: 'DropdownField',
            }
          ]
        });
      }

    }
  }

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.content}>
          {this.state.loading
            ? <Spinner />
            : (
              <GeneralFormComponent
                dropdownLanguages={this.dropdownLanguages}
                onChangeValues={this.generalFormChanges}
                formTitle={this.offerFormTitle}
                fields={this.state.formFields}
                formSchema={this.offerSchema}
                submitButton={this.getSubmitButton()}
                cancelButton={this.getCancelButton()}
                processing={this.state.processing}
              />
            )}
        </div>
      </div>
    );
  }

  async componentDidMount() {
    if (!this.isNew) {
      this.getOffer(this.state.selectedLang);
    }
  }

  getOffer = (langCode: string) => {
    this.setState({
      loading: true,
    });
    this.props.offersStore.getOfferById(this.offerId, langCode)
      .then(async () => {
        await this.updateStateWithOfferData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loading: false,
        });
      });
  };
}

export default withRouter(AddEditOffer);
